var $45bd58553e21ec53$exports = {};
$45bd58553e21ec53$exports = {
    "loading": `Carregando...`,
    "placeholder": `Selecionar\u{2026}`
};


export {$45bd58553e21ec53$exports as default};
//# sourceMappingURL=pt-BR.module.js.map
